import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3z","key":"svg-0"}],["path",{"d":"M18 3a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3z","key":"svg-1"}]]

const IconLayoutCardsFilled = createReactComponent('filled', 'layout-cards-filled', 'LayoutCardsFilled', __iconNode);

export default IconLayoutCardsFilled;